import { useEffect, useMemo, useState } from 'react'

const RESERVATION_MINUTES = 15

export function useReservationTimer(ticketsLockedByUser: any[] | undefined) {
    const [now, setNow] = useState(Date.now())

    // Find EARLIEST locked_at
    const earliestLockTime = useMemo(() => {
        if (!ticketsLockedByUser || ticketsLockedByUser.length === 0) return null

        const times = ticketsLockedByUser.map((t) => (t.locked_at ? new Date(t.locked_at).getTime() : null)).filter(Boolean) as number[]

        if (times.length === 0) return null

        return Math.min(...times)
    }, [ticketsLockedByUser])

    // Update current time every second
    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 1000)
        return () => clearInterval(interval)
    }, [])

    const timeLeftMs = useMemo(() => {
        if (!earliestLockTime) return 0
        const expiry = earliestLockTime + RESERVATION_MINUTES * 60_000
        return Math.max(0, expiry - now)
    }, [earliestLockTime, now])

    const formatted = useMemo(() => {
        if (!earliestLockTime) return ''

        if (timeLeftMs <= 0) {
            return 'A foglalás lejárt, kérjük kezdje újra a vásárlást.'
        }

        const totalSeconds = Math.floor(timeLeftMs / 1000)
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = totalSeconds % 60

        return `Foglalás lejár: ${minutes}:${seconds.toString().padStart(2, '0')}`
    }, [timeLeftMs, earliestLockTime])

    return { timeLeftMs, formatted }
}
